import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { checkReferralCode } from "../../services/engagementService";
import { normalizeReferralCode, rememberReferralCode } from "../../utils/referral";

/**
 * Watches every route for ?ref=CODE (a friend's share link) and remembers the code once the
 * API confirms it exists, so the signup form can send it later. Renders nothing. Mounted once
 * at the App root, next to <Analytics>.
 */
export default function ReferralCapture() {
  const location = useLocation();

  useEffect(() => {
    // react-snap prerenders public pages in a headless browser - never call the API from there.
    if (typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap") return;
    const code = normalizeReferralCode(new URLSearchParams(location.search).get("ref"));
    if (!code) return;
    let active = true;
    checkReferralCode(code)
      .then((valid) => {
        if (active && valid) rememberReferralCode(code);
      })
      .catch(() => {
        /* couldn't check right now - the next page with ?ref= will try again */
      });
    return () => {
      active = false;
    };
  }, [location.search]);

  return null;
}
